import type { PretextFontConfig } from './types';

/**
 * Font strings that match the CSS font stack from doc 13.
 * These must match what the browser resolves for the actual CSS classes.
 */
export const LAUNCH_FONTS: PretextFontConfig = {
  display: '600 48px "Instrument Serif", serif',
  ui: '400 16px "Manrope", sans-serif',
};

/** Build a pretext-compatible font string */
export function buildFontString(
  weight: number,
  size: number,
  family: 'display' | 'ui'
): string {
  const families = {
    display: '"Instrument Serif", serif',
    ui: '"Manrope", sans-serif',
  };
  return `${weight} ${size}px ${families[family]}`;
}
